import { useEffect } from "react";
import '../styles/popup.css';
import useProjectManagementStore from "../store/useProjectManagementStore";
import useProjectManagementHook from "../hooks/useProjectManagementHook";
import ModelPopup from "../../modelManagement/components/ModelPopup"
import { getLoggedInOwnerId } from "../../../../utils/auth";
import { useSwal } from "../../../../components/Notifications/swal/SwalCom";
const ProjectPopup = ({ isModalOpen, handleCloseModal }) => {
    const {
        projectName,
        setProjectName,
        projectDetailInputField,
        setProjectDetailInputField,
        projectInfo,
        popupType
    } = useProjectManagementStore();
    

    const { handler } = useProjectManagementHook();
    const { swalFail } = useSwal();

    // Initialize local input fields when modal opens or projectInfo changes
    useEffect(() => {
        if (isModalOpen) {
            setProjectName(projectInfo?.name || "");
            setProjectDetailInputField(projectInfo?.detail || "");
        }
    }, [isModalOpen, projectInfo, setProjectName, setProjectDetailInputField]);

    const handleSave = () => {
        
        const params = new FormData();
        params.append("name", projectName);
        params.append("detail", projectDetailInputField);
        const ownerId = getLoggedInOwnerId();
        if (!ownerId) {
            swalFail("Missing user", "Unable to determine logged in user. Please login again.");
            return;
        }
        params.append("owner_id", ownerId);
        if (projectInfo?._id) {
            params.append("id", projectInfo?._id || null);
            
            handler.handleEditProject(params);
        }
        else {
            handler.handleSaveProject(params);
        }
    };

    return (
        <>
            {(isModalOpen && popupType == "project") && (
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title h4">
                                    <i className={`fa ${projectInfo ? "fa-edit" : "fa-plus"}`}></i>{" "}
                                    {projectInfo ? "Edit Project" : "Add New Project"}
                                </h5>
                                <button type="button" className="close" onClick={handleCloseModal}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label className="col-form-label">Project name:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={projectName}
                                            onChange={(e) => setProjectName(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="col-form-label">Project detail:</label>
                                        <textarea
                                            className="form-control"
                                            value={projectDetailInputField}
                                            onChange={(e) => setProjectDetailInputField(e.target.value)}
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>
                                    {projectInfo ? "Update" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {(isModalOpen && popupType == "model") && (
                <ModelPopup isModalOpen={true} handleCloseModal={handleCloseModal} projectInfo={projectInfo} ></ModelPopup>
            )}

        </>
    );
};

export default ProjectPopup;
